module.exports = __webpack_public_path__ + "media/src/assets/Images/SearchIcon-bcdcc6587c228fefe11b1d7067f34efb.svg";